import api from "../api/axios";
import { CreateApplicantPayload } from "../Types/Applicants/Application";

//TYPES
import {
  UpdateAddressPayload,
  UpdateApplicantPayload,
} from "../Types/Applicants/Application";

export const APPLICANTS_QUERY_KEY = ["applicants"];
export const VIEW_CANDIDATES_QUERY_KEY = ["view-candidates"];

export const applicantsService = {
  createApplication: async (payload: CreateApplicantPayload) => {
    const response = await api.post(`api/applicants`, payload);
    return response.data;
  },
  uploadProfile: async (application_no: string, payload: FormData) => {
    return api.post(
      `api/applicants/${application_no}/profile-picture`,
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  },
  updateAddress: async (
    application_no: string,
    payload: UpdateAddressPayload,
  ) => {
    const response = await api.patch(
      `api/applicants/${application_no}`,
      payload,
    );
    return response.data;
  },
  updateApplicantInfo: async (
    application_no: string,
    payload: UpdateApplicantPayload,
  ) => {
    const response = await api.patch(
      `api/applicants/${application_no}`,
      payload,
    );
    return response.data;
  },
  getAllApplicants: async () => {
    const response = await api.get(`api/applicants`);
    return response.data;
  },
  getApplicantsByApplicationNo: async (application_no: string) => {
    const response = await api.get(`api/applicants/${application_no}`);
    return response.data;
  },
  getAllCandidates: async () => {
    const response = await api.get(`api/view-candidates`);
    return response.data;
  },
  getAllByStatus: async (status: string) => {
    const response = await api.get(`api/view-candidates/${status}/status`);
    return response.data;
  },
  getCandidateProfile: async (application_no: string) => {
    const response = await api.get(
      `api/view-candidate-profile/${application_no}`,
    );
    return response.data;
  },
};
